import { Typography, Table, TableBody, TableCell, TableRow, TableHead, Grid } from '@material-ui/core';
import { FileIcon, MediaThumb } from "components";
import { IMessage } from '../TicketPrint';
import moment from 'moment';
import Moment from 'react-moment';

interface IProps {
    message: IMessage
}

let Message = ({ message }: IProps) => {
    return (
        <>
            <Typography><b>{message.createdBy}, {`${moment(message.createdOn).format("MMM D YYYY")}`} </b></Typography>
            <Typography variant="body1" dangerouslySetInnerHTML={{ __html: message.text }}></Typography>

            {message.attachments.filter(x => x.isImage === false).length > 0 &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>File</TableCell>
                            <TableCell>Uploaded from</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {message.attachments
                            .filter(x => x.isImage === false)
                            .map((file, index) =>
                                <TableRow key={index}>
                                    <TableCell>
                                        <FileIcon extension={file.extension} />&nbsp;{file.fileName}
                                    </TableCell>
                                    <TableCell>
                                        {file.createdBy}&nbsp;{file.createdByCompany &&
                                            <>&nbsp;&middot;&nbsp;{file.createdByCompany}&nbsp;</>}on&nbsp;
                                        <Moment date={file.createdOn} format="MMM D YYYY" />
                                    </TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                </Table>
            }

            {message.attachments.filter(x => x.isImage === true).length > 0 &&
                <Grid container>
                    {message.attachments
                        .filter(x => x.isImage === true)
                        .map(file =>
                            <Grid key={file.fileId} item style={{ pageBreakInside: 'avoid' }}>
                                <MediaThumb
                                    extension={file.extension}
                                    height={150}
                                    width={150}
                                    fileId={file.fileId}
                                    fileIds={
                                        [...message.attachments]
                                        .filter(x => x.isImage === true)
                                        .map(file => file.fileId)
                                    }
                                    isImage={file.isImage}
                                    isReadOnly={true}
                                />
                            </Grid>
                        )
                    }
                </Grid>
            }
        </>
    )
}

export default Message;